import React from 'react';

interface ChartContainerProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Reusable container component for charts with consistent styling
 * Provides the standard chart card appearance with theme support
 */
export const ChartContainer: React.FC<ChartContainerProps> = ({
  children,
  className = '',
}) => {
  return (
    <div
      className={`flex flex-col rounded-2xl bg-white shadow-xl ${className}`}
    >
      {children}
    </div>
  );
};
